<template>
  <div>
    <div>
      <transition
        name="verification-slide-down"
        tag="div"
      >
        <div v-if="verificationType">
          <MetroTAP
            v-if="verificationType == 'metro_tap'"
            @back="selectVerificationType(null)"
          />
          <CaliforniaEBT
            v-if="verificationType == 'california_ebt'"
            @back="selectVerificationType(null)"
          />
          <DisabilityVerification
            v-if="verificationType == 'disability'"
            @back="selectVerificationType(null)"
          />
          <StudentVerification
            v-if="verificationType == 'student'"
            @back="selectVerificationType(null)"
          />
          <SeniorSelfCertVerification
            v-if="verificationType == 'senior'"
            @back="selectVerificationType(null)"
          />
        </div>
      </transition>
    </div>
    <transition
      name="verification-slide-down"
      tag="div"
    >
      <div v-if="!verificationType">
        <h2>
          Reduced Fare Options
        </h2>
        <p>There are {{ verificationTypes.length }} ways to verify your eligibility for a reduced fare pass. Please select the verification method you would like to use.</p>
        <div class="verification-types">
          <VerificationType
            v-for="verification in verificationTypes"
            :key="verification.type"
            :title="verification.title"
            :image="verification.image"
            :description="verification.description"
            @select="selectVerificationType(verification.type)"
          />
        </div>
      </div>
    </transition>
    <PreviousStepButton
      v-if="!verificationType"
      @click="stepBack"
    />
  </div>
</template>

<script>
import VerificationType from './VerificationType.vue';
import PreviousStepButton from '../PreviousStepButton.vue';
import MetroTAP from './metro_validation_types/MetroTAP.vue';
import CaliforniaEBT from './metro_validation_types/CaliforniaEBT.vue';
import DisabilityVerification from './metro_validation_types/DisabilityVerification.vue';
import SeniorSelfCertVerification from './metro_validation_types/SeniorSelfCertVerification.vue';
import StudentVerification from './metro_validation_types/StudentVerification.vue';

export default {
  components: {
    MetroTAP,
    CaliforniaEBT,
    DisabilityVerification,
    PreviousStepButton,
    VerificationType,
    StudentVerification,
    SeniorSelfCertVerification,
  },
  data() {
    return {
      verificationTypes: [
        {
          title: 'Reduced Fare TAP Card',
          description: 'For Transit Assistance Program cardholders',
          type: 'metro_tap',
          image: 'tap-icon.svg',
        },
        {
          title: 'Golden State Advantage',
          description: 'For CalFresh EBT cardholders',
          type: 'california_ebt',
          image: 'ebt-icon.svg',
        },
        {
          title: 'Disability',
          description: 'For people with ADA-recognized disabilities',
          type: 'disability',
          image: 'disabled-icon.svg',
        },
        {
          title: 'Student',
          description: 'For students 16 or older',
          type: 'student',
          image: 'student-icon.svg',
        },
        {
          title: 'Senior',
          description: 'For seniors 62 or older',
          type: 'senior',
          image: 'senior-icon.svg',
        },
      ],
    };
  },
  computed: {
    steps() {
      return this.$store.getters.steps;
    },
    verificationType() {
      return this.$store.state.registration.discountEligibilityType;
    },
  },
  methods: {
    selectVerificationType(discountEligibilityType) {
      this.$store.dispatch('updateRegistration', {
        discountEligibilityType,
      });
    },
    stepBack() {
      const currentStepIndex = this.steps.indexOf(this.$route.name);
      let prevRoute = null;
      if (currentStepIndex !== 0) {
        prevRoute = this.steps[currentStepIndex - 1];
      }

      this.$router.push({ name: prevRoute, params: { discount: true } });
    },
  },
};
</script>
